// extracted by mini-css-extract-plugin
module.exports = {"footer":"style-module--footer--38qRu","footerInner":"style-module--footerInner--y-Awz","name":"style-module--name--1Khcc","link":"style-module--link--PqSIF"};